import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import dateformat from "dateformat";
import TypeUtils from "../lib/TypeUtils";
import ContentUtils from "../lib/ContentUtils";

export default class ContentRow extends Component {
  static contextTypes = {
    type: PropTypes.object
  };

  static propTypes = {
    content: PropTypes.object,
    columns: PropTypes.array,
    onClick: PropTypes.func
  };

  renderPart(field) {
    const { content } = this.props;
    const { type } = this.context;

    if (field === "date_created") {
      return dateformat(new Date(content[field]), "ddd mmmm dd, yyyy HH:MM");
    }

    const partDefinition = type.parts.find(part => part.name === field);
    return ContentUtils.renderPart(content, field, partDefinition);
  }

  render() {
    const {
      columns,
      content,
      onClick,
      isDragging,
      connectDragSource,
      connectDragPreview
    } = this.props;
    const { type } = this.context;

    const canSort = TypeUtils.sortable(type);
    const activeState = cn("list-state", {
      active: content.active,
      inactive: !content.active
    });

    return connectDragPreview(
      <div
        onClick={onClick}
        className={cn("content-row", "main-action", {
          placeholder: isDragging
        })}
      >
        <div className="content-cell first">
          {canSort && connectDragSource(<div className="handle" />)}
          <div className={activeState} />
        </div>
        {columns.map(column => {
          return (
            <div
              className="content-cell"
              key={column.name}
              data-label={column.label}
            >
              {this.renderPart(column.name)}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ContentRow.js